import { getAuth } from 'firebase/auth';
import { AuthTokenProvider } from './AuthTokenProvider';

export class FirebaseAuthTokenProvider implements AuthTokenProvider {
  async getToken(): Promise<string | null> {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return null;
    return user.getIdToken();
  }
}
